import { ApiMediaCommentsCommentTypeChoices, ApiVideoSessionSessionStatusChoices } from "@api/graphql/types-and-hooks";

export const EMOJI_BUTTONS = [
  { emoji: "❤️", text: "Love", value: ApiMediaCommentsCommentTypeChoices.Love },
  { emoji: "👍", text: "Praise", value: ApiMediaCommentsCommentTypeChoices.Praise },
  { emoji: "💫", text: "Feedback", value: ApiMediaCommentsCommentTypeChoices.Feedback },
  { emoji: "🤔", text: "Question", value: ApiMediaCommentsCommentTypeChoices.Question },
] as const;

export const NO_MEDIA_STATUS = [
  ApiVideoSessionSessionStatusChoices.Failed,
  ApiVideoSessionSessionStatusChoices.Processing,
  ApiVideoSessionSessionStatusChoices.Scheduled,
  ApiVideoSessionSessionStatusChoices.Uploading,
];
